import { App } from 'vue';
import { VueQueryPlugin } from '@libs/use';

const install = (app: App) => {
  app.use(VueQueryPlugin);
};

export { install };
